<template>
  <div class="focus">
    <h2 class="focus__heading">Mé zaměření</h2>
      <FocusLink v-for="(item, index) in focusLinks" :key="index" :item="item" class="focus__link"></FocusLink>
  </div>
</template>

<script>
import FocusLink from "@/components/FocusLink";

export default {
  data() {
    return {
      focusLinks: [
        { 'src': '/img/up.svg', 'alt': 'Územní plán', 'heading': 'Urbanismus a<br>územní plánování', 'url':'/urbanismus' },
        { 'src': '/img/dum.svg', 'alt': 'Rodinný dům', 'heading': 'Architekrura', 'url':'/architektura' },
        { 'src': '/img/grafika.svg', 'alt': 'Grafika', 'heading': 'Fotografie a<br>grafický design', 'url':'/grafika' }
        ],
    };
  },
  components: {
    FocusLink,
  },
};
</script>
<style>
.focus {
  grid-column: span 2;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 48px;
}

.focus__heading {
  grid-column: span 3;
  text-align: center;
}

.focus__link {
  grid-column: span 3;
}

@media only screen and (min-width: 800px) {
  .focus__link {
    grid-column: span 1;
  }
}
</style>